module.exports = __webpack_public_path__ + "img/jorgePena.045f26ac.webp";